import { JsonResponse } from '@client/core/data/concerns/parses-from-json';
import { MemberAccountPreferenceKey } from '@client/features/member-account/types';

export class MemberAccountPreference<T = JsonResponse> {
  constructor(public readonly id: number, public readonly key: MemberAccountPreferenceKey, public readonly value: T) {}
}
